import { SVGPropsIcon } from 'src/types';

export const HeartIcon = ({ isFavorite, ...props }: SVGPropsIcon) => {
  if (isFavorite) {
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        viewBox="0 0 25 25"
        fill="none">
        <g clipPath="url(#clip0_18383_18799)">
          <path
            d="M12.5977 5.89668C13.8052 4.28846 15.7423 3.33704 17.9548 3.33704C19.716 3.33902 21.4045 4.03953 22.6498 5.28488C23.8952 6.53022 24.5957 8.21871 24.5977 9.97989C24.5977 17.4799 13.4773 23.5506 13.0037 23.8013C12.8789 23.8685 12.7394 23.9036 12.5977 23.9036C12.4559 23.9036 12.3164 23.8685 12.1916 23.8013C11.718 23.5506 0.597656 17.4799 0.597656 9.97989C0.599641 8.21871 1.30015 6.53022 2.5455 5.28488C3.79084 4.03953 5.47933 3.33902 7.24051 3.33704C9.45301 3.33704 11.3902 4.28846 12.5977 5.89668Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_18383_18799">
            <rect width="24" height="24" fill="white" transform="translate(0.597656 0.620239)" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_19596_48190)">
        <path d="M17.9568 2.71692C15.7443 2.71692 13.8071 3.66835 12.5996 5.27656C11.3921 3.66835 9.45497 2.71692 7.24247 2.71692C5.48128 2.7189 3.7928 3.41941 2.54745 4.66476C1.3021 5.91011 0.601594 7.59859 0.599609 9.35978C0.599609 16.8598 11.72 22.9305 12.1935 23.1812C12.3184 23.2484 12.4579 23.2835 12.5996 23.2835C12.7413 23.2835 12.8809 23.2484 13.0057 23.1812C13.4793 22.9305 24.5996 16.8598 24.5996 9.35978C24.5976 7.59859 23.8971 5.91011 22.6518 4.66476C21.4064 3.41941 19.7179 2.7189 17.9568 2.71692ZM12.5996 21.4455C10.6432 20.3055 2.3139 15.1123 2.3139 9.35978C2.3156 8.05316 2.8354 6.80055 3.75932 5.87663C4.68324 4.95271 5.93585 4.43291 7.24247 4.4312C9.3264 4.4312 11.076 5.5412 11.8068 7.32406C11.8713 7.48127 11.9812 7.61573 12.1224 7.71036C12.2635 7.80499 12.4297 7.85552 12.5996 7.85552C12.7696 7.85552 12.9357 7.80499 13.0769 7.71036C13.218 7.61573 13.3279 7.48127 13.3925 7.32406C14.1232 5.53799 15.8728 4.4312 17.9568 4.4312C19.2634 4.43291 20.516 4.95271 21.4399 5.87663C22.3638 6.80055 22.8836 8.05316 22.8853 9.35978C22.8853 15.1037 14.5539 20.3044 12.5996 21.4455Z" />
      </g>
      <defs>
        <clipPath id="clip0_19596_48190">
          <rect width="24" height="24" transform="translate(0.599609 0.00012207)" />
        </clipPath>
      </defs>
    </svg>
  );
};
